import gql from 'graphql-tag';

export const CreateDispatchDocumentPresignedUploadUrl = gql`
  mutation CreateDispatchIssueDocumentPresignedUploadUrl($input: CreateIssuePresignedUrlInput!) {
    createDispatchIssueDocumentPresignedUploadUrl(input: $input) {
      url
      contentType
    }
  }
`;
